import React from 'react';

import { InputRow } from '../../../helpers/uiComponents/InputRow';

class LinkChecker extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            testLinks: [],
		}
	}
    checkLink() {
		var url = document.getElementById('linkChecker-url').value;
		var sites = []
		var siteList = document.querySelectorAll('.linkChecker-clientList li input:checked');
		var i;
		for (i = siteList.length - 1; i >= 0; i--) {
			var clientUrl = siteList[i].value;
			clientUrl = clientUrl.replace(/\/+$/, "");
			if (!clientUrl.includes("://")) {
				clientUrl = "https://"+clientUrl;
			}
			sites.push(clientUrl+url);
		}

		if (sites.length > 0) {
			this.setState({testLinks: sites});
		} else {
			alert("choose clients from the list to check the link against.");
		}
	}
    render() {
        const {testLinks} = this.state;
        const clients = this.props.clients;

        return(
            <div className="tab blog-4">
                <h2>Article Link Checker</h2>
                    <li>1. Enter a relative path (/some-link/some-page)</li>
                    <li>2. Select the clients you would like to check the link against.</li>
                    <li>3. run the link builder</li>
                    <li>4. click the links and check all the pages are valid</li>
                

                <ol id="link-results">
                    {testLinks.map(link =>
                        <li><a href={link} target="_blank" rel="noopener noreferrer">{link}</a></li>
                    )}
                </ol>

                <InputRow label="Link" type="text" property="linkChecker-url" id="linkChecker-url" description="\/something\/something-else" />

                <div className="input-row">
                    <label>Build Links</label>
                    <button onClick={() => this.checkLink()} className="button">Run</button>
                </div>
                <ul className="linkChecker-clientList">
                    {clients.map((client) => ((client.velocity === true) && (client.productionUrl !== "http://example.com")) &&
                        ( <React.Fragment key={client.clientCode}>
                            <li>
                                <input type="checkbox" value={client.productionUrl} />
                                <span>{client.name}</span>
                            </li>
                        </React.Fragment> )
                    )}
                </ul>
            </div>
        )
    }
}
export default LinkChecker;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogProfile/BlogLinkChecker.js